import { render, staticRenderFns } from "./selectDialog.vue?vue&type=template&id=5c865e21"
import script from "./selectDialog.vue?vue&type=script&lang=js"
export * from "./selectDialog.vue?vue&type=script&lang=js"
import style0 from "./selectDialog.vue?vue&type=style&index=0&id=5c865e21&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports